<template>
  <svg
    class="svg-icon"
    aria-hidden="true">
    <use :xlink:href="iconName"/>
  </svg>
</template>

<script>
export default {
  name: 'IconSvg',
  props: {
    iconClass: {
      type: String,
      required: true
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Icon-svg/index.vue?4af6f05a